<template>
  <ul class="timeline">

      <template v-for="(testimony, index) in history">
        <li class="time-label">
              <span v-if="testimony.updatedAt && (index === 0 || !sameDate(testimony.updatedAt, history[index - 1].updatedAt))" class="bg-orange">
                {{testimony.updatedAt | prettyDate}}
              </span>
              <span v-if="!testimony.updatedAt" class="bg-orange">
                {{testimony.creationDate | prettyDate}}
              </span>
        </li>

        <li>
          <i class="fa fa-envelope bg-red"></i>

          <div class="timeline-item">
            <span v-if="testimony.updatedAt" class="time"><i class="fa fa-clock-o"></i> {{testimony.updatedAt | prettyTime}}</span>
            <span v-if="!testimony.updatedAt" class="time"><i class="fa fa-clock-o"></i> {{testimony.creationDate | prettyTime}}</span>

            <h3 v-if="!testimony.updatedAt && testimony.victimIdentity" class="timeline-header">
              <strong>{{testimony.purpose !== 'VICTIM' ? (testimony.witnessIdentity.name ? testimony.witnessIdentity.name : 'An anonymous person') : (testimony.victimIdentity.name ? testimony.victimIdentity.name : 'An anonymous person')}}</strong> has created the testimony as a {{testimony.purpose}}
            </h3>
            <h3 v-if="testimony.updatedAt && testimony.updatedBy" class="timeline-header">
              <strong>{{testimony.updatedBy.firstName+' '+testimony.updatedBy.lastName}} ({{testimony.updatedBy.role}})</strong> has updated the testimony
            </h3>

            <div class="timeline-body">
              <template v-for="message in customizeDiff(history[index], history[index + 1])"><span v-html="message"></span></template>
            </div>
          </div>
        </li>

      </template>

    </ul>
</template>

<script>
  import moment from 'moment'
  import api from '../../api'
  import diff from 'deep-diff'

  export default {
    name: 'Timeline',
    props: ['id', 'testimony'],
    data () {
      return {
        history: []
      }
    },
    methods: {
      sameDate (firstDate, secondDate) {
        return moment(firstDate).isSame(secondDate, 'day')
      },
      getDiff (firstDoc, secondDoc) {
        const differences = diff(firstDoc, secondDoc)
        if (differences) {
          const filteredDifferences = differences.filter((difference) => {
            return !difference.path.some((path) => {
              return path === 'updatedAt' || path === 'updatedBy' || path === 'version'
            })
          })
          return filteredDifferences
        } else {
          return []
        }
      },
      customizeDiff (firstDoc, secondDoc) {
        if (!firstDoc || !secondDoc) {
          return []
        }
        const differences = this.getDiff(firstDoc, secondDoc)
        return differences.map((difference) => {
          if (difference.path.indexOf('anchoredAt') !== -1) {
            return `This <strong><i>testimony</i></strong> has been anchored and secured for later use\n`
          } else if (difference.path.indexOf('cases') !== -1) {
            if (difference.item && difference.item.kind === 'D') {
              return `This testimony has been attached to a <strong><i>case</i></strong> : <strong><i>${difference.item.lhs}</strong></i>\n`
            } else if (difference.item && difference.item.kind === 'N') {
              return `This testimony has been detached from a <strong><i>case</i></strong> : <strong><i>${difference.item.rhs}</strong></i>\n`
            } else if (difference.kind === 'N') {
              return `This testimony has been detached from a <strong><i>case</i></strong> : <strong><i>${difference.rhs}</strong></i>\n`
            } else if (difference.kind === 'D') {
              return `This testimony has been attached to a <strong><i>case</i></strong> : <strong><i>${difference.lhs}</strong></i>\n`
            } else {
              return ``
            }
          } else if (difference.path.indexOf('attachments') !== -1) {
            if (difference.item && difference.item.kind === 'D') {
              return `An <strong><i>attachment</i></strong> has been added to this testimony : <strong><i>${difference.item.lhs}</strong></i>\n`
            } else if (difference.item && difference.item.kind === 'N') {
              return `An <strong><i>attachment</i></strong> has been removed from this testimony : <strong><i>${difference.item.rhs}</strong></i>\n`
            } else if (difference.kind === 'N') {
              return `An <strong><i>attachment</i></strong> has been deleted : <strong><i>${difference.rhs}</strong></i>\n`
            } else if (difference.kind === 'D') {
              return `New <strong><i>attachment</i></strong> has been uploaded : <strong><i>${difference.lhs}</strong></i>\n`
            } else {
              return ``
            }
          } else {
            return `Field <strong><i>${difference.path}</i></strong> has been updated :<br>${difference.rhs ? difference.rhs : '<i>No data</i>'} &nbsp;&nbsp;&nbsp;<i class="fa fa-long-arrow-right"></i> &nbsp;&nbsp;&nbsp;${difference.lhs}\n`
          }
        })
      },
      getHistory () {
        api.authenticatedRequest('get', `/testimonies/${this.id}/history`)
          .then(response => {
            this.history = response.data.data.map((testimony) => {
              return testimony.document
            })
            this.history.unshift(JSON.parse(JSON.stringify(this.testimony)))
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getHistory()
      })
    }
  }

</script>



// WEBPACK FOOTER //
// Timeline.vue?ede29e7a